import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAMysOKJopnkO7fKuW9AS3M8T0GhjxFciI",
  authDomain: "jamook-c17e2.firebaseapp.com",
  projectId: "jamook-c17e2",
  storageBucket: "jamook-c17e2.appspot.com",
  messagingSenderId: "177758288745",
  appId: "1:177758288745:web:ed9ec7e9d57adb180f1bf8",
  measurementId: "G-GLR55S23F5",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const googleProvider = new GoogleAuthProvider();
export const auth = getAuth(app);
export const db = getFirestore(app);
